

























































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { AgentModule } from '@/store/modules/agent';
import { AgentTypeEnum } from '@/api/types';
import { list_agent_summaries } from '@/api/agent';
import {
  stringFromIDate,
  stringToIDate,
  formatApiError,
  translateComponentResource,
} from '@/utils/index';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'AgentListSearch',
})
export default class AgentListSearch extends Vue {
  public static readonly agentSearchEvent = 'agent-search';
  private readonly defaultAgentTypes: string[] = Object.values(
    AgentTypeEnum
  ).filter(t => (t as AgentTypeEnum) !== AgentTypeEnum.UNKNOWN_AGENT_TYPE);
  private openPanels = [0];
  private agentTypes = Object.assign([], this.defaultAgentTypes) as string[];
  private agentTypeItems: ItemType[] = [];

  get canSearch() {
    return true;
  }

  mounted() {
    this.loadAgentTypeItems();
    this.loadAgentListSearchForm();
    if (this.canSearch) {
      this.search();
    }
  }

  search() {
    this.$emit(AgentListSearch.agentSearchEvent, {
      agentTypes: this.agentTypes as AgentTypeEnum[],
    } as list_agent_summaries.Request);

    AgentModule.SaveAgentListSearchForm({
      agentTypes: this.agentTypes,
    });
  }

  reset() {
    AgentModule.ClearAgentListSearchForm();
    this.agentTypes = Object.assign([], this.defaultAgentTypes) as string[];
  }

  private loadAgentTypeItems() {
    this.agentTypeItems = this.defaultAgentTypes.map(t => ({
      text: this.$t(`AgentTypeEnum.${t}`) as string,
      value: t,
    }));
  }

  private loadAgentListSearchForm() {
    this.agentTypes = AgentModule.agentListSearchForm.agentTypes;
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }
}
